import itarango from "@/assets/portfolio/itarango.png";
import lanceRapido from "@/assets/portfolio/lance-rapido.png";
import rifaFacil from "@/assets/portfolio/rifa-facil.png";
import institutoMakir from "@/assets/portfolio/instituto-makir.png";
import veForte from "@/assets/portfolio/ve-forte.png";
import jmpContabil from "@/assets/portfolio/jmp-contabil.png";
import mq7Tech from "@/assets/portfolio/mq7-tech.png";
import pdvx from "@/assets/portfolio/pdvx.png";

export type Projeto = {
  nome: string;
  segmento: string;
  descricao: string;
  imagem: string;
};

export const projetos: Projeto[] = [
  {
    nome: "ItaRango",
    segmento: "Food Tech",
    descricao:
      "Cardápio digital com link único, pedidos em tempo real e painel completo para delivery e balcão.",
    imagem: itarango,
  },
  {
    nome: "Lance Rápido",
    segmento: "Imobiliário",
    descricao:
      "Plataforma de leilões imobiliários com busca avançada, calculadora e mais de 29 mil imóveis.",
    imagem: lanceRapido,
  },
  {
    nome: "RifaFácil",
    segmento: "Pagamentos & PIX",
    descricao:
      "Criação de rifas online com PIX integrado, dashboard em tempo real e sorteio auditável.",
    imagem: rifaFacil,
  },
  {
    nome: "Instituto Makir",
    segmento: "ONG & Impacto Social",
    descricao:
      "Site institucional editorial para ONG, com transparência, áreas de atuação e captação de apoiadores.",
    imagem: institutoMakir,
  },
  {
    nome: "VE Forte Soluções",
    segmento: "Engenharia & Construção",
    descricao:
      "Landing page robusta para empresa de engenharia, com captura de orçamentos e portfólio de obras.",
    imagem: veForte,
  },
  {
    nome: "JMP Contábil",
    segmento: "Contabilidade",
    descricao:
      "Site de alta conversão para escritório contábil, com abertura de empresa online e suporte via WhatsApp.",
    imagem: jmpContabil,
  },
  {
    nome: "MQ7 Tech",
    segmento: "Infraestrutura & TI",
    descricao:
      "Site corporativo para empresa de tecnologia: firewall gerenciado, CFTV e outsourcing de impressão.",
    imagem: mq7Tech,
  },
  {
    nome: "PDVX",
    segmento: "SaaS para Óticas",
    descricao:
      "Sistema completo de gestão para óticas com pupilômetro digital, controle de vendas e estoque.",
    imagem: pdvx,
  },
];